import { tv, VariantProps } from 'tailwind-variants';

const spinner = tv({
  base: 'aspect-square w-6 border-[3px] rounded-full animate-spin',
  variants: {
    shade: {
      primary: 'border-brand-color-green border-r-transparent',
      secondary: 'border-brand-color-green border-r-transparent',
      gray: 'border-gray-04 border-r-transparent',
      blue: 'border-cx-blue border-r-transparent',
      failed: 'border-cx-failed border-r-transparent',
      control: 'border-control border-r-transparent',
    },
  },
  defaultVariants: { shade: 'primary' },
});

interface SpinnerProps extends VariantProps<typeof spinner> {
  className?: string;
}

export default function Spinner({ className, shade }: SpinnerProps) {
  return <div className={spinner({ className, shade })}></div>;
}
